import { render } from "./appHeader.vue?vue&type=template&id=b8d1acf8&scoped=true"
const script = {}

import "./appHeader.vue?vue&type=style&index=0&id=b8d1acf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.2.13_webpack@5.88.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8d1acf8"]])

export default __exports__